
import { useRef, useLayoutEffect } from "react";
// --- gsap ----------------------------------------------------------------
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// --- swiper ----------------------------------------------------------------
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
// --- lottie ----------------------------------------------------------------
import Lottie from "lottie-react";
import contactLogo from "../../assets/lotties/logo-purple.json";
// --- img ----------------------------------------------------------------
import { 
  kakaoIcon,
  serviceLesson01,
  serviceLesson02,
  serviceLesson03,
  serviceLesson04,
  serviceLesson05,
  serviceSlide01,
  serviceSlide02,
  serviceSlide03,
  serviceSlide04,
 } from "../../assets/images";
 // --- style ----------------------------------------------------------------
 import "./Service.scss";

function AcademyZone() {
  const heroImages = [serviceSlide01, serviceSlide02, serviceSlide03, serviceSlide04];
  // --- 애니메이션 ----------------------------------------------------------------
  const scopeRef = useRef(null);
  // motion 1 animation
  useLayoutEffect(() => {
    const el = scopeRef.current;
    if (!el) return;

    const ctx = gsap.context(() => {
      const cards = Array.from(el.children);


      gsap.set(cards, { autoAlpha: 0, y: 24 });

      gsap.to(cards, {
        autoAlpha: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.45,
        scrollTrigger: {
          trigger: el, 
          start: "top 75%",
          once: true,
        },
      });
    }, scopeRef);

    return () => ctx.revert();
  }, []);    
  return (
    <div className="content-section academy">
      {/* === SLIDER === */}
      <div className="academy__slider">     
        <Swiper
          modules={[Autoplay]}
          loop
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          slidesPerView="auto"
          centeredSlides
          className="hero-swiper"
        >
          {heroImages.map((img, i) => (
            <SwiperSlide key={i} className="hero-slide">
              <img src={img} alt="" />
            </SwiperSlide>
          ))}
        </Swiper>

        
        <p className="desc">
          MOB 레슨 프로그램은 단순한 레슨이 아닙니다.<br />
          실전 중심의 커리큘럼으로, 아티스트가 직접 수익을 <span className="spacing">창출할 수 있는 시스템을 제공합니다.</span>          
        </p>
      </div>

      {/* === LESSON PROGRAM === */}
      <section className="visual__service max-12">
        <div className="content-section__title">
          <span>보컬, 작곡, AI음악, 수익화까지</span>
          <h3 className="gfont">LESSON PROGRAM</h3>
        </div>
        <ul ref={scopeRef} className="service-content">
          <li>
            <img src={serviceLesson01} alt="" aria-hidden="true" />
            <div className="descrption lesson">
              <h4>VOCAL LESSON</h4>
              <p className="lesson-desc">
                <small>발성, 톤, 라이브 퍼포먼스 - 음원 제작</small>
                <small>개별 레슨 1:1</small>
              </p>            
            </div>
          </li>
          <li>
            <img src={serviceLesson02} alt="" aria-hidden="true" />
            <div className="descrption lesson">
              <h4>COMPOSITION LESSON</h4>
              <p className="lesson-desc">
                <small>작곡 · 편곡 · 프로듀싱 / 코드 · 리듬 · 구조</small>
                <small>Logic / Studio One 기반</small>
              </p>
            </div>
          </li>
          <li>
            <img src={serviceLesson03} alt="" aria-hidden="true" />
            <div className="descrption lesson">
              <h4>Al Music & Lylic Lesson</h4>
              <p className="lesson-desc">
                <small>Ai 작곡 · Ai 작사 실습 </small>
                <small>Chat GPT & SUNO & 뮤직온더블록 활용 실습형 워크숍</small>
              </p>
            </div>
          </li>
          <li>
            <img src={serviceLesson04} alt="" aria-hidden="true" />
            <div className="descrption lesson">
              <h4>DJ LESSON</h4>
              <p className="lesson-desc">
                <small>리믹스 / 공연 실전 세팅 실습형</small>
                <small>(콘솔 · CDJ 사용)</small>
              </p>
            </div>
          </li>
          <li>
            <img src={serviceLesson05} alt="" aria-hidden="true" />
            <div className="descrption lesson">
              <h4>브랜딩 영상</h4>
              <p className="lesson-desc">
                <small>AI 영상 · 뮤직 비디오 제작 / 클링 · 미드저니</small>
                <small>TTS · SUNO 및 뮤직온더블록 활용</small>
              </p>
            </div>          
          </li>
        </ul>
      </section>    

      {/* === CURRICULUM === */}
      <section className="academy__curriculum">
        <div className="max-12">
          <h3 className="gfont">CURRICULUM</h3>
          <p className="desc">MOB studio만의 특별한 학습을 만나보세요</p>

          {/* --- 컨텐츠 영역 --- */}
          {/* ONE-DAY */}
          <div className="one-day">
            <div className="title">
              <h4 className="tit gfont">
                ONE-DAY
                <span>CLASS</span>
              </h4>
              <p className="subtit">하루만에 완성하는 나만의 음악</p>
            </div>

            {/* --- 컨텐츠 영역 --- */}
            <div className="one-day-list">
              <ul>
                <li>
                  <strong>01</strong>
                  <dl>
                    <dt>OT 10분</dt>
                    <dd>AI음악 트렌드 & 수익화 구조 안내 (흐름 이해)</dd>
                  </dl>
                </li>
                <li>
                  <strong>02</strong>
                  <dl>
                    <dt>음원 편집 & 커버 제작</dt>
                    <dd>
                      간단한 편집 툴 / 커버 이미지 자동 생성<br />
                      표지 완성 및 파일 저장<br />
                      클링/미드저니 이미지 생성<br />
                      캡컷 제작                        
                    </dd>
                  </dl>
                </li>
              </ul>
              <ul>
                <li>
                  <strong>03</strong>
                  <dl>
                    <dt>AI 작사 · 작곡 · 영상 제작 체험</dt>
                    <dd>
                      SUNO /Udio/ MOB AI 작곡 실습<br />
                      장르, 키워드 입력 → 자동 생성<br />
                      Chat GPT 기반 작사 툴 실습<br />
                      주제/감정 선택 → 트렌드 기반 가사 생성<br />
                      가사 구조 이해                        
                    </dd>
                  </dl>
                </li>
                <li>
                  <strong>04</strong>
                  <dl>
                    <dt>유통 & 수익화 안내</dt>
                    <dd>
                      음원 유통 과정 / 저작권 등록 방법<br />
                      MOB 플랫폼 수익화 구조 소개                        
                    </dd>
                  </dl>
                </li>
              </ul>
            </div>     
          </div>      

          {/* FULL CLASS */}
          <div className="full-class">
            <div className="title">
              <h4 className="tit gfont">
                FULL CLASS
                <span>PACKAGE</span>
              </h4>
              <p className="subtit">FULL CLASS</p>
            </div>
            <p className="session-desc">
              <span>
                COURSE<b>총 8회 2개월</b>
              </span>
              <span>
                TIME<b>2회차 회당 60분</b> 
              </span>
            </p>
            <ul className="fullclass-list">
              <li>
                <strong>STEP 01</strong>
                <p>AI 음악 창작  (Composition & Lyrics)</p>
              </li>
              <li>
                <strong>STEP 02</strong>
                <p>AI 비주얼 제작 (Visual Creation)</p>
              </li>
              <li>
                <strong>STEP 03</strong>
                <p>SNS 콘텐츠 전략 (Social Branding)</p>
              </li>
              <li>
                <strong>STEP 04</strong>
                <p>음원 유통 & 수익화 (Distribution & Monetization)</p>
              </li>
            </ul>

            {/* Results & Rewards */}
            <div className="title">
              <h5 className="tit-small gfont">
                Results & Rewards
              </h5>
              <p className="subtit">패키지 수강 후 얻을 수 있어요</p>            
            </div>
            <ul className="reward-list">
              <li>
                <strong>01</strong>
                <p>음원 1-2곡 (AI 또는 협업작)</p>
              </li>
              <li>
                <strong>02</strong>
                <p>AI 영상 뮤직 비디오 / 숏폼 1편 이상</p>
              </li>
              <li>
                <strong>03</strong>
                <p>SNS 브랜드 계정 세팅 TicTok</p>
              </li>
              <li>
                <strong>04</strong>
                <p>Youtube shorts 연동</p>
              </li>
              <li>
                <strong>05</strong>
                <p>
                  수익화 구조 연동 MOB 플랫폼<br /> 
                  크리에이터 등록 + 음원 유통
                </p>
              </li>
              <li>
                <strong>06</strong>
                <p>프로필 등록</p>
              </li>
              <li>
                <strong>07</strong>
                <p>MOB 취업 시스템 </p>
              </li>
            </ul>

          </div>
        </div>
      </section>

      {/* === EDUDATION 동영상 === */}
      {/* <section className="academy__education">
        <div className="content-section__title max-12">
          <span>보컬·작곡·AI 실습에 최적화된 환경에서 효율적으로 배울 수 있습니다</span>
          <h3 className="gfont">EDUCATION ENVIRONMENT</h3>
        </div>        
      </section> */}
      
      {/* === INSTRUCTOR PORTFOLIO === */}
      {/* <section className="academy__education max-12">
        <div className="content-section__title">
          <span>음악으로 길을 만든 사람들, 그들의 경험을 당신에게 전합니다</span>
          <h3 className="gfont">INSTRUCTOR PORTFOLIO</h3>
        </div>        
      </section> */}

      {/* === INQUIRY === */} 
      <div className="content-section__contact">
        <p className="desc">
          ALL MAKERS, ONE STAGE. 지금 당신의 무대를 시작하세요
        </p>
        <h3 className="gfont title">
          RESERVATION INQUIRY
        </h3>
        <Lottie
          animationData={contactLogo}
          loop
          autoplay
          className="contact-lottie"
        />

        <div className="kakao-link">
          <span>지금 시작해 보세요.</span>
          <a 
          href="https://pf.kakao.com/_QLTxgn"
          target="_blank"
          rel="noopener noreferrer"
          >
            <img src={kakaoIcon} alt="" aria-hidden="true" />
            카카오 채널 문의
          </a>
        </div>
      </div>         
    </div>
  )
}

export default AcademyZone